import { render, staticRenderFns } from "./cancelindividualEnroll.vue?vue&type=template&id=5147925b&"
import script from "./cancelindividualEnroll.vue?vue&type=script&lang=js&"
export * from "./cancelindividualEnroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports